import { useEffect, useState } from 'react';

export const useIsMobile = (maxWidth: number = 767) => {
    const [isMobile, setIsMobile] = useState(
        window.matchMedia(`(max-width: ${maxWidth}px)`).matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);

        const handler = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, []);

    return isMobile;
}